export const toTitleCase = (str: string) => {
    return str
        .toLowerCase() // First, convert the entire string to lowercase
        .replace(/\b\w/g, (match) => match.toUpperCase()); // Capitalize the first letter of each word
};

